import React, { useContext, useEffect, useState } from "react";

import AuthButton from "../header/AuthButton";

import Search from "../header/Search";
import { useLocation, useNavigate } from "react-router-dom";

import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../firebase/firebaseConfig";
import { useAppContext } from "../../AppContext";
import { useTranslation } from "react-i18next";
import i18n from "../../locales/i18n";
import HeaderTop from "../header/HeaderTop";
import HeaderMobile from "../header/HeaderMobile";
interface HeaderProps {
  selectedTab: string;
  setSelectedTab: (tab: string) => void;
}

const Header: React.FC<HeaderProps> = ({ selectedTab, setSelectedTab }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isRTL, setIsRTL] = useState<boolean>(i18n.language === "ar");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [runAnimation, setRunAnimation] = useState(false);
  // const [user,setUser]=useState<any>(null)
  const { search, setSearch, role } = useAppContext();
  const { modalMode, setModalMode, showModal, setShowModal } = useAppContext();
  const user = useAppContext().user;

  // Add useEffect to handle language changes
  useEffect(() => {
    const handleLanguageChange = () => {
      setIsRTL(i18n.language === "ar");
    };

    i18n.on("languageChanged", handleLanguageChange);
    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, []);

  // useEffect(() => {
  //     const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
  //         setUser(currentUser);
  //     });
  //     return () => unsubscribe();
  // }, [auth]);

  const handleTabClick = (tab: string, path: string) => {
    console.log("calling tab", tab, path);
    setSelectedTab(tab);
    setSearch("");
    navigate(path);
    setRunAnimation(!runAnimation);
    setTimeout(() => setIsMenuOpen(!isMenuOpen), !isMenuOpen ? 0 : 500);
  };

  const handleLoginClick = () => {
    setModalMode("login");
    setShowModal(true);
  };

  const handleRegisterClick = () => {
    setModalMode("register");
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSearch = () => {
    if (search) {
      navigate(`/book-store?search=${encodeURIComponent(search)}`);
    } else {
      navigate("/book-store");
    }
  };

  const location = useLocation();

  // useEffect(() => {
  //   if (location.state?.showLogin === true) {
  //     setShowModal(true);
  //   }
  // }, [location, navigate]);

  useEffect(() => {
    const searchParam = new URLSearchParams(window.location.search).get(
      "search"
    );
    if (searchParam) {
      setSearch(decodeURIComponent(searchParam));
    }
  }, [location]);

  useEffect(() => {
    console.log("calling selectedTab", selectedTab);
  }, [selectedTab]);

  return (
    <div
      className="w-full z-50"
      style={{ boxShadow: "0px 5px 10px 0px #1919191A" }}
    >
        <HeaderTop 
            setIsMenuOpen={setIsMenuOpen} 
            runAnimation={runAnimation} 
            setRunAnimation={setRunAnimation}
            isMenuOpen={isMenuOpen} 
            search={search} 
            setSearch={setSearch} 
            onSearch={handleSearch} 
            handleLoginClick={handleLoginClick} 
            handleRegisterClick={handleRegisterClick}
        />

      <HeaderMobile 
          runAnimation={runAnimation} 
          handleRegisterClick={handleRegisterClick} 
          handleLoginClick={handleLoginClick} 
          handleTabClick={handleTabClick} 
          user={user} 
          role={role}
          setRunAnimation={setRunAnimation}
          setIsMenuOpen={setIsMenuOpen}
      />

      <div className="w-full h-[80px] lg:h-[70px] flex items-center justify-center bg-white lg:bg-primary_500 xl:bg-primary_500 border-b border-gray lg:border-0 xl:border-0 lg:px-10 xl:px-28 md:px-10 px-5">
        <div className="w-full gap-[64px] justify-center  items-center h-full hidden lg:flex xl:flex">
          {role !== "publisher" && (
            <div
              className={`h-full ${
                selectedTab === "home" ? "justify-between" : "justify-center"
              } flex flex-col`}
            >
              {selectedTab === "home" && (
                <div className="h-[6px] bg-primary_500 rounded-t-md animate-underline " />
              )}
              <button
                className="text-white h-full semibold-text top-7"
                onClick={() => handleTabClick("home", "/home")}
              >
                {t("navigation.home")}
              </button>
              {selectedTab === "home" && (
                <div className="h-[6px] white-low-opacity rounded-t-md animate-underline" />
              )}
            </div>
          )}
          {role !== "publisher" && user && (
            <div
              className={`h-full ${
                selectedTab === "profile?page=My Library" ? "justify-between" : "justify-center"
              } flex flex-col`}
            >
              {selectedTab === "profile?page=My Library" && (
                <div className="h-[6px] bg-primary_500 rounded-t-md animate-underline " />
              )}
              <button
                className="text-white h-full semibold-text top-7"
                onClick={() => handleTabClick("profile?page=My Library", "/profile?page=My Library")}
              >
                {t("navigation.myLibrary")}
              </button>
              {selectedTab === "profile?page=My Library" && (
                <div className="h-[6px] white-low-opacity rounded-t-md animate-underline" />
              )}
            </div>
          )}
 


          <div
            className={`h-full ${
              selectedTab === "bookStore" ? "justify-between" : "justify-center"
            } flex flex-col`}
          >
            {selectedTab === "bookStore" && (
              <div className="h-[6px] rounded-t-md animate-underline z-10 bg-transparent" />
            )}
            <button
              className="text-white h-full semibold-text"
              onClick={() => handleTabClick("bookStore", "/book-store")}
            >
              {role == "publisher"
                ? t("navigation.myBooks")
                : t("navigation.bookStore")}
            </button>
            {selectedTab === "bookStore" && (
              <div className="h-[6px] white-low-opacity rounded-t-md animate-underline" />
            )}
          </div>


          {role == "publisher" && (
            <div
              className={`h-full ${
                selectedTab === "purchases"
                  ? "justify-between"
                  : "justify-center"
              } flex flex-col`}
            >
              {selectedTab === "purchases" && (
                <div className="h-[6px] rounded-t-md animate-underline z-10 bg-transparent" />
              )}
              <button
                className="text-white h-full semibold-text"
                onClick={() => handleTabClick("purchases", "/purchases")}
              >
                {t("navigation.purchases")}
              </button>
              {selectedTab === "purchases" && (
                <div className="h-[6px] white-low-opacity rounded-t-md animate-underline" />
              )}
            </div>
          )}
          {role == "publisher" && (
            <div
              className={`h-full ${
                selectedTab === "reports" ? "justify-between" : "justify-center"
              } flex flex-col`}
            >
              {selectedTab === "reports" && (
                <div className="h-[6px] rounded-t-md animate-underline z-10 bg-transparent" />
              )}
              <button
                className="text-white h-full semibold-text"
                onClick={() => handleTabClick("reports", "/reports")}
              >
                {t("navigation.reports")}
              </button>
              {selectedTab === "reports" && (
                <div className="h-[6px] white-low-opacity rounded-t-md animate-underline" />
              )}
            </div>
          )}
          <div
            className={`h-full ${
              selectedTab === "faqs" ? "justify-between" : "justify-center"
            } flex flex-col`}
          >
            {selectedTab === "faqs" && (
              <div className="h-[6px] rounded-t-md animate-underline z-10 bg-transparent" />
            )}
            <button
              className="text-white h-full semibold-text"
              onClick={() => handleTabClick("faqs", "/faqs")}
            >
              {t("navigation.faqs")}
            </button>
            {selectedTab === "faqs" && (
              <div className="h-[6px] white-low-opacity rounded-t-md animate-underline" />
            )}
          </div>
          <div
            className={`h-full ${
              selectedTab === "contactUs" ? "justify-between" : "justify-center"
            } flex flex-col`}
          >
            {selectedTab === "contactUs" && (
              <div className="h-[6px] rounded-t-md animate-underline z-10 bg-transparent" />
            )}
            <button
              className="text-white h-full semibold-text"
              onClick={() => handleTabClick("contactUs", "/contact-us")}
            >
              {t("navigation.contactUs")}
            </button>
            {selectedTab === "contactUs" && (
              <div className="h-[6px] white-low-opacity rounded-t-md animate-underline" />
            )}
          </div>
          {/* {role !== "publisher" && (
            <div
              className={`h-full ${
                selectedTab === "privacyPolicies"
                  ? "justify-between"
                  : "justify-center"
              } flex flex-col`}
            >
              {selectedTab === "privacyPolicies" && (
                <div className="h-[6px] rounded-t-md animate-underline z-10 bg-transparent" />
              )}
              <button
                className="text-white h-full semibold-text"
                onClick={() =>
                  handleTabClick("privacyPolicies", "/privacy-policies")
                }
              >
                {t("navigation.privacyPolicies")}
              </button>
              {selectedTab === "privacyPolicies" && (
                <div className="h-[6px] white-low-opacity rounded-t-md animate-underline" />
              )}
            </div>
          )} */}
          {role !== "publisher" && (
            <div
              className={`h-full ${
                selectedTab === "support" ? "justify-between" : "justify-center"
              } flex flex-col`}
            >
              {selectedTab === "support" && (
                <div className="h-[6px] rounded-t-md animate-underline z-10 bg-transparent" />
              )}
              <button
                className="text-white h-full semibold-text"
                onClick={() => handleTabClick("support", "/support")}
              >
                {t("navigation.helpSupport")}
              </button>
              {selectedTab === "support" && (
                <div className="h-[6px] white-low-opacity rounded-t-md animate-underline" />
              )}
            </div>
          )}
          {/* {role !== "publisher" && (
            <div
              className={`h-full ${
                selectedTab === "termsAndConditions"
                  ? "justify-between"
                  : "justify-center"
              } flex flex-col`}
            >
              {selectedTab === "termsAndConditions" && (
                <div className="h-[6px] bg-transparent rounded-t-md animate-underline w-full z-0" />
              )}
              <button
                className="text-white h-full semibold-text"
                onClick={() =>
                  handleTabClick("termsAndConditions", "/terms-and-conditions")
                }
              >
                {t("navigation.termsConditions")}
              </button>
              {selectedTab === "termsAndConditions" && (
                <div className="h-[6px] white-low-opacity rounded-t-md animate-underline w-full" />
              )}
            </div>
          )} */}
        </div>
        <div className="w-full lg:hidden ">
          <Search
            search={search}
            setSearch={setSearch}
            onSearch={handleSearch}
          />
        </div>
      </div>

    </div>
  );
};

export default Header;
